import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getEventDetailRequest, getEventDetailRequestError, getEventDetailRequestSuccess } from "../../slices/event-management/EventDetailSlice";

export const GetEventDetailApi = (eventId) => async (dispatch) => {

    const url = `${endpoints.eventDetail}?eventId=${eventId}`
    try {
        dispatch(getEventDetailRequest());
        axiosInstance({
            method: "GET",
            url: url,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getEventDetailRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getEventDetailRequestError(_error));
            });
    } catch (error) { }
};
